import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController,AlertController} from 'ionic-angular';
import { B05PurchaseOrderPage } from '../b05-purchase-order/b05-purchase-order';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B05aPurchaseInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface purchaseInfo{
  PO_ID: number;
  PO_NO: string;
  REMARKS: string; 
  TOTAL_FOREX: string;
  TOTAL_LOCAL: string;  
  TOTAL_TAX: string; 
  GRAND_TOTAL: string;  
  DATETIME: string; 
  PO_STATUS_ID: number;
  PO_TYPE_ID: number;
  SUPPLIER_ID: number;
  CURRENCY_ID: number;
  ACTION_BY: number;
}
interface POLInfo{};
interface inventoryInfo{
  INVENTORY_ID: number;
  INVENTORY_ITYPE_ID: number;
  ITEM_DESC: string;
  COST: string;
  SELLING_PRICE: string;
  INVENTORY_ACTIVE: string;
}
interface polstatusInfo{};
interface GRInfo{};
@IonicPage()
@Component({
  selector: 'page-b05a-purchase-info',
  templateUrl: 'b05a-purchase-info.html',
})


export class B05aPurchaseInfoPage {
  loading: any;
  Status:any;
  public errorMessage: any = "";
  supplier_name:any;
  purchaseArr: purchaseInfo[] = [];
  purchaseItems: purchaseInfo[] = [];
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  polstatusArr: polstatusInfo[] = [];
  polstatusItems: polstatusInfo[] = [];
  polArr: POLInfo[] = [];
  polItems: POLInfo[] = [];
  GRItems: GRInfo[] = [];
  GR_NO: GRInfo[] = [];
  overlayHidden: boolean = true;
  overlayHidden1: boolean = true;
  selected_pol_id:any;
  selected_pol_desc:any;
  selected_pol_qty:any;
  receivedQTY:any;
  inventory_qty:any;
  selected_inv_id:any;
  Date:any;
  userId:any;
  pol_list = [];
  outstanding_list = [];
  inventory_list = [];
  branch_name:any;
  outstanding:any;
  PO_ID:any;
  qtyerror:any;
  constructor(public navCtrl: NavController, public alertCtrl:AlertController, public serviceapi: ServiceApiProvider,public navParams: NavParams, public loadingCtrl:LoadingController) {
    let PO_ID = this.navParams.get('paramID'); 
    this.PO_ID = PO_ID;
    this.userId = sessionStorage.getItem('userid');


    this.showLoader();

    let tbl = ["PO"];
    let column = ["PO_ID"];
    let value = [PO_ID];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
    
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    

    this.serviceapi.readdata(json_data,"PO","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        console.log("A1");
        let Records = result["Records"];
        this.purchaseArr = Records[0];
        this.purchaseItems = this.purchaseArr;
   
        //Branch
        let tbl = ["BRANCH"];
        let column = ["BRANCH_ID"];
        let value = [this.purchaseItems['BRANCH_ID']];

        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");


        this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
          this.Status = result["Message"];
          if (this.Status == '1'){
                 console.log("A2");
                let Records = result["Records"];
                let data = Records[0];
                this.branch_name = data['BRANCH_NAME'];
                //Supplier


                  let tbl = ["All"];
                  let column = ["All"];
                  let value = ["All"];

                  let tblkey = ["No"];
                  let fktbl = ["No"];
                  let fkkey = ["No"];

                  let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                  let mydata = Object.assign(jsonitem);
                  let json_data = this.serviceapi.json_readdata(mydata,"1");
                

                  this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
                  
                    this.Status = result["Message"];
                    if (this.Status == '1'){
                      console.log("A3");
                      let Records = result["Records"];
                      this.inventoryArr = Records;
                      this.inventoryItems = this.inventoryArr;
                    
                
                      let tbl = ["All"];
                      let column = ["All"];
                      let value = ["All"];

                      let tblkey = ["No"];
                      let fktbl = ["No"];
                      let fkkey = ["No"];

                      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                      let mydata = Object.assign(jsonitem);
                      let json_data = this.serviceapi.json_readdata(mydata,"1");
                    

                      this.serviceapi.readdata(json_data,"POL_STATUS","1","1").then((result) => {
                      
                        this.Status = result["Message"];
                        if (this.Status == '1'){
                          
                          let Records = result["Records"];
                          this.polstatusArr = Records;
                          this.polstatusItems = this.polstatusArr;
                    
                          let tbl = ["SUPPLIER"];
                          let column = ["SUPPLIER_ID"];
                          let value = [this.purchaseItems['SUPPLIER_ID']];

                          let tblkey = ["No"];
                          let fktbl = ["No"];
                          let fkkey = ["No"];

                          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                          let mydata = Object.assign(jsonitem);
                          let json_data = this.serviceapi.json_readdata(mydata,"1");
                        

                          this.serviceapi.readdata(json_data,"SUPPLIER","1","1").then((result) => {
                          
                            this.Status = result["Message"];
                            if (this.Status == '1'){
                              
                              let Records = result["Records"];
                              let data = Records[0];
                              this.supplier_name = data['SUPPLIER_NAME'];
                        
                              console.log( this.supplier_name);
                              let tbl = ["POL"];
                              let column = ["PO_ID"];
                              let value = [PO_ID];
                      
                              let tblkey = ["No"];
                              let fktbl = ["No"];
                              let fkkey = ["No"];
                      
                              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                      
                              let mydata = Object.assign(jsonitem);
                              let json_data = this.serviceapi.json_readdata(mydata,"1");
                            
                      
                              this.serviceapi.readdata(json_data,"POL","1","1").then((result) => {
                              
                                this.Status = result["Message"];
                                if (this.Status == '1'){
                                  
                                  let Records = result["Records"];
                                
                                  this.polArr = Records;
                                  this.polItems = this.polArr;
                                  //Start Inventory
                                
                                  let i = 0
                                  for(i=0;i<this.polItems.length;i++)
                                  {
                                      let polval = this.polItems[i];
                                      this.pol_list.push(polval["POL_ID"]);
                                      this.inventory_list.push(polval["INVENTORY_ID"]);
                                      let tbl = ["POL_GR"];
                                      let column = ["POL_ID"];
                                      let value = [polval["POL_ID"]];

                                      let tblkey ="No";
                                      let fktbl = "No";
                                      let fkkey = "No";

                                      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                                      let mydata = Object.assign(jsonitem);
                                      let json_data = this.serviceapi.json_readdata(mydata,"1");
                                    

                                      this.serviceapi.readdata(json_data,"POL_GR","1","1").then((result) => {
                                      
                                        this.Status = result["Message"];
                                      
                                        if (this.Status == '1'){
                                          
                                          let Records = result["Records"];
                                        
                                          let j = 0;
                                          let total = 0;
                                          for(j=0;j<Records.length;j++)
                                          {
                                            let receive = Records[j];
                                            total = total + parseFloat(receive["RECEIVE_QTY"]);
                                          }
                                        
                                          polval["RECEIVED"] = total;
                                          polval["OUTSTANDING"] = polval["QTY"] - total;
                                          this.outstanding_list.push(polval["OUTSTANDING"]);
                                          console.log("A"+this.outstanding_list)
                                        
                                        }
                                        else {
                                          polval["RECEIVED"] = 0;
                                          polval["OUTSTANDING"] = polval["QTY"];
                                          this.outstanding_list.push(polval["OUTSTANDING"]);
                                          console.log("B"+this.outstanding_list)
                                        
                                        }
                                        
                                      }, (err) => {
                                        this.errorMessage = "Loading Error. Please try again.";
                                        this.loading.dismiss();
                                      });
                                    }
                                  
                                  //End
                                  
                                  this.loading.dismiss();
                                  //console.log(this.polItems);
                                }
                                else {
                                  this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                                  this.loading.dismiss();
                                }
                              }, (err) => {
                                this.errorMessage = "Loading Error. Please try again.";
                                this.loading.dismiss();
                              });
                            }
                            else {
                              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                              this.loading.dismiss();
                            }
                          
                          }, (err) => {
                            this.errorMessage = "Loading Error. Please try again.";
                            this.loading.dismiss();
                          });
                        }
                        else {
                          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                          this.loading.dismiss();
                        }
                      
                      }, (err) => {
                        this.errorMessage = "Loading Error. Please try again.";
                        this.loading.dismiss();
                      });

                    }
                    else {
                      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                      this.loading.dismiss();
                    }
                  
                }, (err) => {
                  this.errorMessage = "Loading Error. Please try again.";
                  this.loading.dismiss();
                });


          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });

      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B05aPurchaseInfoPage');
  }

  fullReceived(){

    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Do you want to do full receive?',
      buttons: [
        {
          text: 'No',
          handler: () => {
          console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
          console.log('Agree clicked');
            
          this.full_receive_all();

         
          }
        }
      ]
    });
    confirm.present();
    
  }

  full_receive_all()
  {
    console.log(this.pol_list);
    this.showLoader();
    
    let good_receive = {Param:'', PO_ID:'', UserID:'',POL_ID:[],RECEIVE_QTY:[],BRANCH_ID:'',INVENTORY_ID:[],POL_STATUS_ID:[],PO_STATUS_ID:''};
    good_receive.Param = "2";
    good_receive.POL_ID = this.pol_list;
    good_receive.PO_ID = this.purchaseItems["PO_ID"];
    good_receive.UserID = this.userId;
    let z:number;
    let out_list = [];
    for(z = 0;z<this.polItems.length;z++)
    {
        let k = this.polItems[z];
        console.log(k["OUTSTANDING"]);
        out_list.push(k["OUTSTANDING"]);
    }
    good_receive.RECEIVE_QTY = out_list;
    good_receive.INVENTORY_ID = this.inventory_list;
    good_receive.BRANCH_ID = this.purchaseItems["BRANCH_ID"];
    let i = 0;
    let pol_status = [];
    console.log(this.outstanding_list);
    for(i=0;i<this.outstanding_list.length;i++)
    {
      pol_status.push("3");
    }
    good_receive.POL_STATUS_ID = pol_status;
    good_receive.PO_STATUS_ID = "4";
    console.log(good_receive);
    this.serviceapi.goodreceivedata(good_receive).then((result) => {
         
      this.Status = result["Message"];
      let group = result["GR_ID"];
      console.log(this.Status);
      if (this.Status == '1'){
        this.loading.dismiss();
        //let group = result["GR_ID"];
        console.log(">"+group);
        this.serviceapi.printDocument('3',group,"1").then((result) => {     //view report
          let Records = result["Records"];
          console.log(Records);
          window.open(Records, '', 'height=400,width=600');
        });
        //this.navCtrl.setRoot(B05PurchaseOrderPage);
        this.navCtrl.pop();
        this.navCtrl.push(B05aPurchaseInfoPage, {paramID: this.navParams.get('paramID')});  
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }
  editPOL(data,outstanding)
  {
    this.selected_pol_id = data;
    this.outstanding = outstanding;
    let val = this.polItems.find(c => c["POL_ID"] === data);
    this.selected_pol_desc =val["POL_DESC"];
    this.selected_pol_qty =val["QTY"];
    this.selected_inv_id = val["INVENTORY_ID"];
    
    this.overlayHidden = false;
  }
  /*partialReceived(){
    this.navCtrl.setRoot(B05PurchaseOrderPage);
  }*/

  goTo(){
    this.navCtrl.setRoot(B05PurchaseOrderPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  hideOverlay() {
    
    this.overlayHidden = true;
    console.log("hide");
  }
  hideOverlay1() {
    
    this.overlayHidden1 = true;
    console.log("hide");
  }
  update()
  {
    console.log(this.receivedQTY);
    console.log(this.outstanding);
    if((parseFloat(this.outstanding) >= parseFloat(this.receivedQTY)) && (parseFloat(this.receivedQTY) > 0))
    {
        this.showLoader();
        
        let good_receive = {Param:'', PO_ID:'', UserID:'',POL_ID:'',RECEIVE_QTY:'',BRANCH_ID:'',INVENTORY_ID:'',POL_STATUS_ID:'',PO_STATUS_ID:''};
        good_receive.Param = "1";
        good_receive.PO_ID = this.purchaseItems["PO_ID"];
        good_receive.POL_ID = this.selected_pol_id;
        good_receive.UserID = this.userId;
        good_receive.RECEIVE_QTY = this.receivedQTY;
        good_receive.INVENTORY_ID = this.selected_inv_id;
        good_receive.BRANCH_ID = this.purchaseItems["BRANCH_ID"];
        if(this.outstanding == this.receivedQTY)
        {
            good_receive.POL_STATUS_ID = "3";
        }
        else
        {
            good_receive.POL_STATUS_ID = "2";
        }
        let i = 0;
        let count = 0;
        console.log(">>"+this.polItems.length);
        for(i=0;i<this.polItems.length;i++)
        {
            let val = this.polItems[i];
            if(val["POL_STATUS_ID"] == "3")
            {
              count++;
            
            }
            else
            {
              if(val["POL_ID"] == this.selected_pol_id)
              {
                if(good_receive.POL_STATUS_ID == "3")
                  count++;
              }
            }

            if(count == this.polItems.length)
              good_receive.PO_STATUS_ID = "4";
            else
              good_receive.PO_STATUS_ID = "3";
        }
        console.log(good_receive.PO_STATUS_ID);
        
        this.serviceapi.goodreceivedata(good_receive).then((result) => {
            
          this.Status = result["Message"];
          
          console.log(this.Status);
          if (this.Status == '1'){
            this.loading.dismiss();
            this.qtyerror = "";
            let group = result["GR_ID"];
            console.log(">"+result["GR_ID"]);
            this.serviceapi.printDocument('3',group,"1").then((result) => {     //view report
              let Records = result["Records"];
              console.log(Records);
              window.open(Records, '', 'height=400,width=600');
            });
            //this.navCtrl.setRoot(B05PurchaseOrderPage);
            this.navCtrl.pop();
            this.navCtrl.push(B05aPurchaseInfoPage, {paramID: this.navParams.get('paramID')});  
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else if(parseFloat(this.receivedQTY) < 0)
      {
        this.qtyerror = "Received quantity should not be negative";
        console.log("wrong");
      }
      else
      {
        this.qtyerror = "Received quantity should not more than Outstanding";
        console.log("wrong");
      }
  }

  showdescname(data)
  {
   let val = this.inventoryItems.find(c => c["INVENTORY_ID"] === data);
   if(val == undefined)
      return "Inventory ID "+data+" Is Removed";
   else
      return val["ITEM_DESC"];
   //this.supplier_type = val["TYPE"];
   //this.supplier_type_id  = val["SUPPLIER_TYPE_ID"];
  }
  showpolstatus(data)
  {
   let val = this.polstatusItems.find(c => c["POL_STATUS_ID"] === data);
   return val["STATUS"];
   //this.supplier_type = val["TYPE"];
   //this.supplier_type_id  = val["SUPPLIER_TYPE_ID"];
  }

  viewPO(){
    this.serviceapi.printDocument('1',this.PO_ID,"2").then((result) => {
      let Records = result["Records"];
      window.open(Records, '', 'height=400,width=600');
    });
  }
  reprint()
  {
    this.overlayHidden1 = false;
    let grp_data="";
    for(let i = 0; i<(this.polArr).length;i++)
    {
      let b = this.polArr[i];
      console.log(b["POL_ID"]);
      let tbl = ["POL_GR"];
      let column = ["POL_ID"];
      let value = [b["POL_ID"]];

      let tblkey = ["GR_ID"];
      let fktbl = ["GOOD_RECEIVE"];
      let fkkey = ["GR_ID"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
    

      this.serviceapi.readdata(json_data,"POL_GR","1","1").then((result) => {
      
        this.Status = result["Message"];
      
        if (this.Status == '1'){
          
          let Records = result["Records"];
          
          for(let z = 0; z<Records.length;z++)
          {
            let k = Records[z];
            
            console.log("GR_ID"+k["GR_ID"]);
            
             if((this.GRItems).indexOf(k["GR_ID"]) == -1)
             {
              let gr_json = {"GR_ID":"", "GR_NO":""};
              gr_json.GR_ID = k["GR_ID"];
              gr_json.GR_NO = k["GR_NO"];
              console.log("GR_ID_enter"+k["GR_ID"]);
              this.GRItems.push(k["GR_ID"])
              this.GR_NO.push(gr_json);
             }
           /*if(grp_data == "")
              grp_data = k["GR_ID"];
            else
              grp_data = grp_data+","+k["GR_ID"];
            if(i === (this.polArr).length -1)
            {
              console.log(grp_data);
              this.serviceapi.printDocument('3',grp_data,"2").then((result) => {     //view report
                let Records = result["Records"];
                console.log(Records);
                window.open(Records, '', 'height=400,width=600');
              });
            }*/
             
          }
          console.log(this.GR_NO);
          this.GR_NO.sort(this.dynamicSort("GR_ID"));
        }
        else {
      
        
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    }
   
  }

  download(id)
  {
    this.overlayHidden1 = false;
    this.serviceapi.printDocument('3',id,"2").then((result) => {     //view report
      let Records = result["Records"];
      console.log(Records);
      window.open(Records, '', 'height=400,width=600');
    });
  }

  dynamicSort(property) {
    return function(a, b) {
        return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
 }
}



// WEBPACK FOOTER //
// ./src/pages/b05a-purchase-info/b05a-purchase-info.ts